import { Routes } from '@angular/router';
import { DetailProjectComponent } from './user/detail-project/detail-project';
import { TaskCreatePageComponent } from './user/detail-project/task-create-page/task-create-page';
import { TaskDetailPageComponent } from './user/detail-project/task-detail-page/task-detail-page';
import { roleGuard } from './auth/guards/auth.guard';
import { Projects } from './user/projects/projects';
import { Activity } from './user/activity/activity';
import { TimeEntryCreatePageComponent } from './user/activity/time-entry-create-page/time-entry-create-page';
import { LoginPageComponent } from './auth/login.page';
import { authGuard } from './auth/guards/auth.guard.simple';
import { AdminLayout } from './admin/layout/admin-layout';
import { AdminEmployeesView } from './admin/views/employees-view';
import { AdminTenantsView } from './admin/views/tenants-view';
import { AdminPhaseModelsView } from './admin/views/phase-models-view';
import { AdminTimeEntriesView } from './admin/views/time-entries-view';
import { AdminApprovalView } from './admin/views/approval-view';
import { AdminReportingView } from './admin/views/reporting-view';
import { ProfileLayout } from './user/profile/layout/profile-layout';
import { AccountView } from './user/profile/views/account-view';
import { SettingsView } from './user/profile/views/settings-view';
import { Dashboard } from './user/dashboard/dashboard';
import { Crm } from './user/crm/crm';
import { TodosComponent } from './user/todos/todos';
import { crmAccessGuard } from './shared/guards/crm-access.guard';
import { OAuthCallbackComponent } from './auth/oauth-callback.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: 'oauth-callback',
    component: OAuthCallbackComponent
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
      },
      {
        path: 'projects',
        component: Projects
      },
      {
        path: 'crm',
        component: Crm,
        canActivate: [crmAccessGuard]
      },
      {
        path: 'dashboard',
        component: Dashboard
      },
      {
        path: 'projects/:id',
        component: DetailProjectComponent
      },
      {
        path: 'projects/:id/phases/:stageId/tasks/new',
        component: TaskCreatePageComponent
      },
      {
        path: 'projects/:id/tasks/:taskId',
        component: TaskDetailPageComponent
      },
      {
        path: 'activity',
        component: Activity
      },
      {
        path: 'activity/time-entries/new',
        component: TimeEntryCreatePageComponent
      },
      {
        path: 'tasks',
        component: TodosComponent
      },
      {
        path: 'todos',
        redirectTo: 'tasks',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        component: ProfileLayout,
        children: [
          {
            path: '',
            redirectTo: 'account',
            pathMatch: 'full'
          },
          {
            path: 'account',
            component: AccountView
          },
          {
            path: 'settings',
            component: SettingsView
          }
        ]
      },
      {
        path: 'admin',
        canActivate: [roleGuard],
        data: { roles: ['SUPERADMIN', 'ADMIN'] },
        component: AdminLayout,
        children: [
          {
            path: '',
            redirectTo: 'employees',
            pathMatch: 'full'
          },
          {
            path: 'employees',
            component: AdminEmployeesView
          },
          {
            path: 'tenants',
            component: AdminTenantsView
          },
          {
            path: 'phase-models',
            component: AdminPhaseModelsView
          },
          {
            path: 'time-entries',
            component: AdminTimeEntriesView
          },
          {
            path: 'approval',
            component: AdminApprovalView
          },
          {
            path: 'reporting',
            component: AdminReportingView
          }
        ]
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'projects',
    pathMatch: 'full'
  }
]
